import { render, staticRenderFns } from "./ProductionOptions.vue?vue&type=template&id=10c84870&scoped=true&"
import script from "./ProductionOptions.vue?vue&type=script&lang=js&"
export * from "./ProductionOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c84870",
  null
  
)

export default component.exports